import React from 'react';
import ProjectItem from '../../../../components/ProjectItem/ProjectItem';

const ProjectsDetailsItems = () => {
   return (
      <>
         <section className="tp-project-details-area tp-prjects-tab-content pb-90">
            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="section-title-wrapper-two mb-55 text-center wow fadeInUp" data-wow-delay=".2s">
                        <h5 className="tp-section-subtitle section__sm__title common-yellow-shape mb-20 heading-color-black">Quelques projets terminés</h5>
                        <h2 className="tp-section-title heading-color-black">Chaque projet est différent <br/>Chaque client est unique</h2>
                     </div>
                  </div>
               </div>
               <div className="row">

                  <ProjectItem project_img_num="1" project_subtitle="Residentiel Service"
                  project_title="Nettoyage de vitres"></ProjectItem>

                  <ProjectItem project_img_num="2" project_subtitle="Residentiel Service"
                  project_title="Nettoyage de Cuisine"></ProjectItem>

                  <ProjectItem project_img_num="3" project_subtitle="Residentiel Service"
                  project_title="Nettoyage Extérieur"></ProjectItem>

               </div>
            </div>
         </section>
      </>
   );
};

export default ProjectsDetailsItems;